@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.card {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: var(--light-60);
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
  @include blur;
  margin-bottom: 8px;
  padding: 16px 12px;

  [data-autopilot-system-redesign='on'] & {
    box-shadow: none;
    border: 1px solid var(--dark-8);
    border: none;
    @include blur(0);
    background: transparent;
    gap: 10px;
    padding: 0;
    margin-bottom: 0;
  }
}

.content {
  padding: 0 8px 2px 8px;

  [data-autopilot-system-redesign='on'] & {
    padding: 0;
  }

  &.withIcon {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    svg {
      flex-shrink: 0;
    }
  }
}
